import React from "react";
import Transactions from "../Orders/Transactions";
import TransactionsClone from "../Orders/TransactionsClone";

export default function TransactionsPage() {
  return (
    <div className="px-10">
      {/* <Transactions loadAll={true} /> */}
      <TransactionsClone loadAll={true} />
    </div>
  );
}
